import React from 'react';
import styled from 'styled-components';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';

import { CardTemplateBalloonShape, CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { CardBalloonShape, CardShapeDb } from '../redux/cardShapeDbSlice';

type ShapeSvgProps = {
  x: number;
  y: number;
  rotation: number;
  selecting?: boolean;
}
const ShapeSvg = styled.svg<ShapeSvgProps>`
  position: absolute;
  border: ${props => props.selecting ? '1px solid blue' : undefined};
  box-sizing: border-box;
  transform: ${props => 'translate(' + props.x + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg) !important'};
  transform-origin: center;
`
type BalloonPathProps = {
  strokeProps: {display: boolean, color: string, opacity: number, width: number};
  fillProps: {display: boolean, color: string, opacity: number};
}
const BalloonPath = styled.path<BalloonPathProps>`
  stroke: ${props => props.strokeProps.color};
  stroke-opacity: ${props => props.strokeProps.display ? props.strokeProps.opacity : 0};
  stroke-width: ${props => props.strokeProps.width};
  fill: ${props => props.fillProps.color};
  fill-opacity: ${props => props.fillProps.display ? props.fillProps.opacity : 0};
`

type BalloonShapeProps = {
  id?: string;
  item: CardTemplateBalloonShape | CardBalloonShape;
  setSelectingId?: (id: string | undefined) => void;
  dragItem?: (data: DraggableData, item: CardTemplateShapeDb | CardShapeDb, id: string) => void;
  scaleValue?: number;
  selecting?: boolean;
}
const BalloonShape: React.FC<BalloonShapeProps> = ({id, item, setSelectingId, dragItem, scaleValue, selecting}) => {
  const sWidthHalf = item.stroke.display ? item.stroke.width / 2 : 0;
  const width = Math.abs(item.width) - sWidthHalf;
  const height = Math.abs(item.height) - sWidthHalf;
  let d = 'M ' + sWidthHalf + ',' + sWidthHalf + ' H ' + width + ' V ' + (height - 10) + ' H 10 L ' + sWidthHalf + ',' + height + ' Z';
  const dXReverse = 'M ' + width + ',' + sWidthHalf + ' H ' + sWidthHalf + ' V ' + (height - 10) + ' H ' + (Math.abs(item.width) - 10) + ' L ' + width + ',' + height + ' Z';
  const dYReverse = 'M ' + width + ',' + height + ' H ' + sWidthHalf + ' V ' + sWidthHalf + ' L 10,10 H ' + width + ' Z';
  const dXYReverse = 'M ' + width + ',' + height + ' H ' + sWidthHalf + ' V 10 H ' + (Math.abs(item.width) - 10) + ' L ' + width + ',' + sWidthHalf + ' Z';
  if (item.width < 0 && item.height < 0) d = dXYReverse;
  else if (item.width < 0) d = dXReverse;
  else if (item.height < 0) d = dYReverse;

  return (
    <Draggable position={{x: item.x, y: item.y}}
      onStart={() => setSelectingId ? setSelectingId(id) : undefined}
      onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem && id ? dragItem(data, item, id) : undefined}
      scale={scaleValue} disabled={!id}>
      <ShapeSvg width={Math.abs(item.width)} height={Math.abs(item.height)}
        x={item.x} y={item.y} rotation={item.rotation} selecting={selecting}
        xmlns="http://www.w3.org/2000/svg">
        <BalloonPath d={d}
          strokeProps={item.stroke} fillProps={item.fill} />
      </ShapeSvg>
    </Draggable>
  );
}

export default BalloonShape;
